module.exports = __webpack_public_path__ + "assets/img/9e9d6ec3f90173f03daca45e96f9795b.svg";